import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, inject, Inject, Output } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-package-of-services',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
  ],
  templateUrl: './package-of-services.component.html',
  styleUrl: './package-of-services.component.scss',
})
export class PackageOfServicesComponent {
  @Output() messageEvent = new EventEmitter<string>();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translateService: TranslateService,
    private router: Router
  ) {}

  viewExample() {
    this.router.navigate(['p', 'pyt67']);
  }

  order() {
    this.router.navigate(['order']);
  }
}
